/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { textFontSize } from 'components/styles';

const styles = {
  badge: css({
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: textFontSize.xs,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
    '&[data-tone="ok"]': { background: '#E3F2E8', color: '#2E7D4F' },
    '&[data-tone="warn"]': { background: '#FDF1DC', color: '#B7791F' },
    '&[data-tone="danger"]': { background: '#FBEAEA', color: '#B23B3B' },
    '&[data-tone="info"]': { background: '#E7ECF4', color: '#0D4796' },
    '&[data-tone="muted"]': { background: '#F5F5F5', color: '#666' },
  }),
};

export type StatusTone = 'ok' | 'warn' | 'danger' | 'info' | 'muted';

/**
 * 状態バッジ（確定済み／編集中／回収中 など）
 */
const StatusBadge: React.FC<{ tone: StatusTone; text: string }> = ({ tone, text }) => (
  <span css={styles.badge} data-tone={tone}>{text}</span>
);

export default StatusBadge;
